import axios from "axios";

import config from "config/config";

function create(apiHost, config) {
  const { ...rest } = config || {};
  const instance = axios.create({
    baseURL: apiHost,
    timeout: 60000,
    withCredentials: true,
    ...rest
  });
  return instance;
}

export const instance = create(config.apiHost, {});
